<template>
	<div class="index-singleImg" :style="{backgroundColor:imgData.bg_color}">
		<template v-for="(single,index) in imgData.single_image">
			<div class="showcase-detail" v-if="single.image">
				<div class='single-item' @click="goDtl(single.path,single.is_hologram)">
					<el-image
						class="product-proImg"
						style="width: 100%;height: auto;display: block;"
						:src="single.image"
						fit="contain">
					</el-image>
				</div>
			</div>
		</template>
	</div>
</template>
<script>
export default {
	name:'singleImage',
	props:{
		imgData:{
			type:Object,
		},
	},
	methods:{
		goDtl(path,type){
			this.$emit('on-modeDtl', path , type);
		},
	}
}
</script>
<style scoped>
/* 单图模块 */
.single-item{
	width: 100vw;
    position: relative;left: 50%;margin-left: -50vw;
}
</style>


// WEBPACK FOOTER //
// src/mode/singleImg.vue